import Head from './../components/Head';
import TeacherCard from './components/teacherCard.vue';
import Footer from '../components/Footer.vue';
import { Empty } from 'zhs-components';
export default {
  created() {
    this.getTeacherSet();
    this.getTeacherCollegeAndTitle();
    this.getTeacherCollege();
    this.getTeacherList();
  },

  components: {
    Head,
    TeacherCard,
    Footer,
    Empty
  },

  data() {
    return {
      menuInfo: {},
      menuId: this.$utils.getUrlParams('menuId'),
      teacherName: '',
      currentCategoryId: -1,
      dialogTeacherVisible: false,
      currentTeacher: {},
      pageInfo: {
        pageIndex: 1,
        rows: 0,
        pageLimit: 9,
        pageLimit2: 45
      },
      teacherList: [],
      collegeList: [],
      // 学院列表
      teacherTitleList: [],
      // 教师称号列表
      searchInfo: {
        userName: '',
        collegeId: '',
        collegeName: '',
        titleId: '',
        titleName: ''
      },
      showMoreTeacherTitle: false,
      // 是否显示更多教师称号
      showMoreCollege: false,
      // 是否显示更多学院
      organ_flag: '',
      showType: '',
      sort: ''
    };
  },

  watch: {
    searchInfo: {
      handler(value) {
        this.pageInfo.pageIndex = 1;
        this.getTeacherList();
      },

      deep: true
    },
    showType: {
      handler(val) {
        this.getTeacherList();
      },

      deep: true
    }
  },
  methods: {
    //获取荣誉称号
    async getTeacherCollegeAndTitle() {
      const categoryInfo = await this.$http.getTeacherTitle({
        menu_id: this.menuId
      });
      console.log('名师-荣誉', categoryInfo);
      this.teacherTitleList = categoryInfo || [];
      let sum = 0;
      this.teacherTitleList.forEach(item => {
        sum += +item.count;
      });
      this.teacherTitleList.unshift({
        honorary_title_name: '全部',
        count: sum,
        honorary_title_id: ''
      });
      console.log(this.teacherTitleList);
      console.log(sum);
    },

    // 获取学院
    async getTeacherCollege() {
      console.log(this.menuId);
      const res = await this.$http.getTeacherCollege({
        menu_id: this.menuId
      });
      console.log('名师-学院', res);
      this.collegeList = res || [];
      let sum = 0;
      this.collegeList.forEach(item => {
        sum += +item.count;
      });
      this.collegeList.unshift({
        organ_name: '全部',
        count: sum,
        organ_id: ''
      });
    },

    // 获取教师列表
    async getTeacherList() {
      const teacherList = await this.$http.getTeacherList({
        '_pageable.size': this.showType == 1 ? this.pageInfo.pageLimit : this.pageInfo.pageLimit2,
        '_pageable.page': this.pageInfo.pageIndex - 1,
        menu_id: this.menuId,
        teacher_name: this.teacherName || undefined,
        honorary_title_id: this.searchInfo.titleId || undefined,
        organ_id: this.searchInfo.collegeId || undefined,
        sort_type: this.sort || undefined
      });
      console.log('名师列表', teacherList);
      this.teacherList = teacherList.content || [];
      this.pageInfo.rows = +teacherList.totalElements || 0;
    },

    handleChangePageSize(pageSize) {
      this.pageInfo.pageLimit = pageSize;
      this.pageInfo.pageIndex = 1;
      this.searchInfo.titleId = '';
      this.searchInfo.collegeId = '';
      this.searchInfo.userName = '';
      this.getTeacherList();
    },

    handleSearch() {
      this.pageInfo.pageIndex = 1;
      this.getTeacherList();
      this.teacherName = '';
    },

    // 清空选中
    clearSelected(index) {
      if (index === 1) {
        this.searchInfo.titleId = '';
      } else if (index === 2) {
        this.searchInfo.collegeId = '';
      }

      this.pageInfo.pageIndex = 1;
    },

    // 切换称号显示
    toggleShowTeacherTitle() {
      this.showMoreTeacherTitle = !this.showMoreTeacherTitle;
    },

    // 切换称号
    teacherTitleChange(item) {
      this.searchInfo.titleId = item.honorary_title_id;
      this.searchInfo.titleName = item.honorary_title_name;
      this.pageInfo.pageIndex = 1; // this.getTeacherList();
    },

    // 切换学院显示
    toggleShowCollege() {
      this.showMoreCollege = !this.showMoreCollege;
    },

    // 切换学院
    collegeChange(id, college_name) {
      this.searchInfo.collegeId = id;
      this.searchInfo.collegeName = college_name;
      this.pageInfo.pageIndex = 1;
    },

    // 切换分页
    pageIndexChange(current) {
      this.pageInfo.pageIndex = current;
      this.getTeacherList();
    },

    // 获取高级设置
    async getTeacherSet() {
      const res = await this.$http.getTeacherSet({
        menu_id: this.menuId
      });
      res.forEach(item => {
        if (item.code == 'teacher_filter') {
          this.organ_flag = item.code_value;
        }

        if (item.code == 'teacher_show_type') {
          this.showType = item.code_value;
        }

        if (item.code == 'teacher_sort') {
          this.sort = item.code_value;
        }
      });
      console.log('师-设置', res);
    },

    goDetail(id) {
      window.location.href = `/teacherDetailInfo.html?id=${id}&name=${this.menuInfo.nav_name}&menuId=${this.menuId}`;
    },

    showType1() {
      this.pageInfo.pageIndex = 1;
      this.showType = 1;
    },

    showType2() {
      this.pageInfo.pageIndex = 1;
      this.showType = 2;
    }

  }
};